/**
 * Send the login form data
 */
window.iniciarSesion = function (event) {
    event.preventDefault();
    cleanFeedback('iniciarSesion', 'iniciarSesionFormulario');
    $("#iniciarSesionError").hide();

    // Procesamos Recaptcha de Google
    let formData = new FormData(event.target);

    appendGRecaptchaResponse(formData, recaptcha_actions.login).then(function (formData) {

        $.ajax({
            url:         urlAutenticacion,
            type:        'POST',
            data:        formData,
            processData: false,
            contentType: false,
            beforeSend:  function () {
                $('#iniciarSesionBotonEnviar').prop('disabled', true);
                $('#iniciarSesionBotonEnviar').html(`<i class="ri-loader-4-line spinner"></i> ${transAccionProcesando}`);
            },
        })
         .done(function (response) {
             // Si la respuesta tiene dominio, es que es un usuario pertenece a otro dominio
             if ('undefined' !== typeof response.dominio) {
                 // Redireccionamos al login por token del otro dominio
                 // @DISCLAIMER Si el protocolo de un dominio a otro varía Ej: dominio 1 = ssl, dominio 2 != ssl -> Entonces la redirección fallará
                 // @TODO: Gestionar el tema del protocolo del dominio por campo en la tabla empresas de la BBDD
                 // @DISCLAIMER Que pasa si en el otro dominio no existe el idioma 'locale' que le pasamos desde este??
                 // @TODO: Comprobar esta casuistica de error y ver que ocurre y como solucionarlo
                 window.location.replace(`${window.location.protocol}//${response.dominio}/${locale}/autenticacion/${response.auth_token}`);
             } else {
                 // Comprobamos si el usuario se encuentra iniciando sesión desde la vista de login
                 if (response.url !== null) {
                     window.location.replace(response.url);
                 } else {
                     // Obviamente, estamos en la vista de login
                     // Si el usuario tiene un rol que permite suplantar redirigimos a la ventana de librerías a suplantar
                     // En caso contrario, redirigimos a la página de inicio
                     const redirectUrl = response.rol !== 3 ? urlSuplantacion : urlInicio;
                     window.location.replace(redirectUrl);
                 }
             }
         })
         .fail(function (jqXHR, status, error) {
             if (jqXHR.status === 422 && jqXHR.responseJSON.errors) {
                 errors = composeValidationError(jqXHR.responseJSON.errors);
             } else if (jqXHR.responseJSON.message) {
                 errors = jqXHR.responseJSON.message;
             }
             $('#iniciarSesionError')
                 .show()
                 .find('span')
                 .html(errors);
         })
         .always(function () {
             $('#iniciarSesionBotonEnviar').prop('disabled', false);
             $('#iniciarSesionBotonEnviar').html(`<i class="ri-login-circle-line align-middle"></i> ${transAccionIniciarSesion}`);
         });
    }).catch(function () {
        $("#iniciarSesionError")
            .show()
            .find("span")
            .text(transGRecaptchaErrorNotValidated);
    });
};
